<template>
  <!-- 生产单详情-生产单表头部分 -->
  <el-descriptions
    border
    size="medium"
    column="4"
    labelStyle="width: 100px"
    contentStyle="width: 250px"
  >
    <el-descriptions-item label="部门">{{
      workOrderHeader.department
    }}</el-descriptions-item>
    <el-descriptions-item label="工单编号">{{
      workOrderHeader.number
    }}</el-descriptions-item>
    <el-descriptions-item label="制单日期">{{
      workOrderHeader.createTime
    }}</el-descriptions-item>
    <el-descriptions-item label="供应商">{{
      workOrderHeader.customer
    }}</el-descriptions-item>

    <el-descriptions-item label="机台">{{
      workOrderHeader.machineNumber
    }}</el-descriptions-item>
    <el-descriptions-item label="产品名称">{{
      workOrderHeader.productName
    }}</el-descriptions-item>
    <el-descriptions-item label="原料编号">{{
      workOrderHeader.materialNumber
    }}</el-descriptions-item>
    <el-descriptions-item label="原料规格">{{
      workOrderHeader.materialSpec
    }}</el-descriptions-item>

    <el-descriptions-item label="机台转速">{{
      workOrderHeader.speed/100
    }} m/min</el-descriptions-item>
    <el-descriptions-item label="D数">{{
      workOrderHeader.dcount
    }} D</el-descriptions-item>

    <el-descriptions-item label="头纹数"
      >{{ workOrderHeader.headLine }} 条</el-descriptions-item
    >
    <el-descriptions-item label="米数"
      >{{ workOrderHeader.clothLength }} 米</el-descriptions-item
    >
    <el-descriptions-item label="圈数"
      >{{ workOrderHeader.turns }} 圈</el-descriptions-item
    >
    <el-descriptions-item label="盘头个数"
      >{{ workOrderHeader.gbCount }} 个</el-descriptions-item
    >
     <el-descriptions-item label="盘头尺寸"
      >{{ workOrderHeader.gbSize/100 }} 英寸</el-descriptions-item
    >
    <el-descriptions-item label="温度"
      >{{ workOrderHeader.temperature }} 度</el-descriptions-item
    >
    <el-descriptions-item label="制单人"
      >{{ workOrderHeader.creator }}</el-descriptions-item
    >

    <el-descriptions-item label="备注">{{
      workOrderHeader.remark
    }}</el-descriptions-item>
  </el-descriptions>
</template>

<script>
export default {
  data() {
    return {
      workOrderHeader: {},
    };
  },
  methods: {
    // 设置表头信息
    setworkOrderHeader(response) {
      console.log(response);
      this.workOrderHeader = this.formatworkOrderHeader(response);
    },
    // 格式化表单信息
    formatworkOrderHeader(res) {
      res.createTime = this.utils.timestampToTime(res.createTime);
      res.department = "生产部"; // 暂时先固定为 '生产部'.
      
      // 已完成. 前端是'米'，后台是'厘米'，提交时*100，显示时/100。
      res.speed = Number(res.speed).toFixed(2); // 浮点数强制显示2位小数。
      

      // status 0=审核不通过(待修改), 1=未审核(待审核), 2=已审核, , 3=结案。
      if (res.status === 3) {
        res.status_change = "结案";
      } else if (res.status === 2) {
        res.status_change = "已审核";
      } else if (res.status === 1) {
        res.status_change = "待审核";
      } else {
        // 0 或者 null
        res.status_change = "待修改";
      }

      // workStatus 上机状态
      // 0 = 准备中  ---->添加工单时，不显示。
      // 1 = 待产    ---->提交工单后，显示 "就绪"="等待"。
      // 3 = 生产中  ---->点击上单后，显示 "上单"="上机"
      // 2 = 暂停    ---->点击下单后，显示 "下单"="下机"
      // 4 = 完成    ---->后台自动切换，显示 "关闭"
      if (res.workStatus === 1) {
        if (res.status === 2) {
          //已审核
          res.workStatus_change = "就绪";
        } else {
          res.workStatus_change = "";
        }
      } else if (res.workStatus === 2) {
        res.workStatus_change = "下单";
      } else if (res.workStatus === 3) {
        res.workStatus_change = "上单";
      } else if (res.workStatus === 4) {
        res.workStatus_change = "关闭";
      } else {
        // 0 或者 null
        res.workStatus_change = "准备中";
      }

      return res;
    },
  },
};
</script>

<style lang="scss" scoped></style>
